import React from "react";
import { connect } from "react-redux";

import { doGetAllMessageLogs } from "../stores/thunk";
import { selectAllMessageLogs } from "../stores/slice";

export default Component => {
  class Container extends React.Component {
    render() {
      return <Component {...this.props} />;
    }
  }
  function mapStateToProps(state) {
    return {
      isFetching: state.messageLog.isFetching,
      status: state.messageLog.status,
      metadata: state.messageLog.metadata,
      messageLogs: selectAllMessageLogs(state),
    };
  }

  return connect(mapStateToProps, {
    doGetAllMessageLogs,
  })(Container);
};
